import Message from './Message'
import styled, { ThemeProvider, useTheme } from 'styled-components'
import { device } from '../../../breakpoints'

const Chat = ({ messages }: { messages: ChatInterface[] }) => {
  return (
    <Container>
      {messages.map((message) => (
        <Message key={`message-${message.id}`} message={message} />
      ))}
    </Container>
  )
}

const Container = styled.div`
  text-align: right;
`

export default Chat
